import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import { Col, Row, Grid, Panel, Button, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../Layout/ContentWrapper';
import checkPermission from '../Common/permissions';
import Spinner from '../Widgets/spinner';
import {
  fetchAgentList,
  changeAgentStatus,
} from '../../actions/agents_actions';
import { companyCodeTitle } from '../../actions/root_url';

const propTypes = {
  value: PropTypes.string,
  dependentValues: PropTypes.shape({
    id: PropTypes.number,
  }),
  onClick: PropTypes.func.isRequired,
};

const defaultProps = {
  value: '',
  dependentValues: {},
};

class AgentManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      agentList: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      isAgentListLoading: false,
    };
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    this.handleFetchAgentList();
  }

  handleFetchAgentList = () => {
    const handleSuccess = (response) => {
      const agentList = { ...this.state.agentList, rows: response };
      this.setState({
        agentList,
        isAgentListLoading: false,
      });
    };

    const handleFailure = () => {
      this.setState({ isAgentListLoading: false });
    };

    this.setState({ isAgentListLoading: true }, () => {
      fetchAgentList(handleSuccess, handleFailure);
    });
  }

  handleChangeStatusClick = (action, id) => {
    const handleSuccess = () => {
      this.handleFetchAgentList();
    };

    const handleFailure = (err) => {
      alert(JSON.stringify(err.data));
    };

    let isActive = false;
    if (action === 'activate') {
      isActive = true;
    }
    changeAgentStatus(id, isActive, handleSuccess, handleFailure);
  }

  renderAgentsTable = () => {

    const getRows = () => Data.Selectors.getRows(this.state.agentList);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const agentList = Object.assign({}, this.state.agentList, { sortColumn, sortDirection });
      this.setState({ agentList });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.agentList.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const agentList = { ...this.state.agentList, filters: newFilters };
      this.setState({ agentList });
    };

    const handleClearFilters = () => {
      const agentList = { ...this.state.agentList, filters: {} };
      this.setState({ agentList });
    };

    const IsActiveFormatter = React.createClass({
      render() {
        if (this.props.value) {
          return (
            <span className="label label-success">
              <Translate value="active" />
            </span>
          );
        }
        return (
          <span className="label label-danger">
            <Translate value="inactive" />
          </span>
        );
      },
    });

    const ActionFormatter = React.createClass({
      render() {
        const { value, dependentValues } = this.props;
        if (value === 'deactivate') {
          return (
            <Button
              bsStyle="primary"
              disabled={!checkPermission('change_agent')}
              onClick={() => this.props.onClick(value, dependentValues.id)}
            >
              <Translate value="deactivate" />
            </Button>
          );
        }
        return (
          <Button
            bsStyle="primary"
            disabled={!checkPermission('change_agent')}
            onClick={() => this.props.onClick(value, dependentValues.id)}
          >
            <Translate value="activate" />
          </Button>
        );
      },
    });

    const columns = [
      {
        key: 'email',
        name: <Translate value="email" />,
        resizable: true,
        width: 220,
        sortable: true,
        filterable: true,
      },
      {
        key: 'firstName',
        name: <Translate value="first_name" />,
        resizable: true,
        width: 180,
        sortable: true,
        filterable: true,
      },
      {
        key: 'lastName',
        name: <Translate value="last_name" />,
        resizable: true,
        width: 180,
        sortable: true,
        filterable: true,
      },
      {
        key: 'phone',
        name: <Translate value="phone" />,
        resizable: true,
        width: 180,
        sortable: true,
        filterable: true,
      },
      {
        key: 'isActive',
        name: <Translate value="status" />,
        resizable: true,
        width: 120,
        sortable: true,
        filterable: true,
        formatter: IsActiveFormatter,
      },
      {
        key: 'action',
        name: <Translate value="action" />,
        resizable: false,
        width: 120,
        sortable: true,
        filterable: true,
        formatter: <ActionFormatter onClick={this.handleChangeStatusClick} />,
        getRowMetaData: row => row,
      },
    ];

    return (
      <ContentWrapper>
        <Row>
          <Col sm={12}>
            <div id="AgentManagement-dataGrid1">
              <ReactDataGrid
                rowKey="id"
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                rowHeight={35}
                onAddFilter={handleFilterChange}
                onClearFilters={handleClearFilters}
                columns={columns}
                minHeight={620}
                rowGetter={rowGetter}
                rowsCount={getSize()}
              />
            </div>
          </Col>
        </Row>
        <Row className="total-users">
          <label htmlFor="total-users">
            <Translate value="total_agents" />:&nbsp;
            <span className="font-color-orange">
              { this.state.agentList.rows.length }
            </span>
          </label>
        </Row>
      </ContentWrapper>
    );
  }

  render() {
    const { isAgentListLoading } = this.state;
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="Admin" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="user_management" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="settings-user-management">
          <Row>
            <Col xs={6}>
              <h1><Translate value="agents" /></h1>
            </Col>
          </Row>
          <Panel>
            {
              isAgentListLoading &&
                <Spinner className="spinner" />
            }
            { this.renderAgentsTable() }
          </Panel>
        </Grid>
      </ContentWrapper>
    );
  }
}

AgentManagement.propTypes = propTypes;
AgentManagement.defaultProps = defaultProps;

export default AgentManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/Agents/AgentManagement.jsx